import * as Types from '../generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type CatalogCurationHeaderFragment = {
  __typename?: 'ProductCatalogCurationHeader';
  textColor?: string | null;
  gradientColor?: string | null;
  gradient1?: string | null;
  gradient2?: string | null;
  title?: string | null;
  eyebrow?: string | null;
  description?: string | null;
  video?: string | null;
  backgroundImage?: { __typename?: 'Photo'; id: string; url: string; blurHash?: string | null } | null;
  logoImage?: { __typename?: 'Photo'; id: string; url: string; blurHash?: string | null } | null;
};

export type CatalogCurationFieldsFragment = {
  __typename?: 'ProductCatalogCategory';
  id: string;
  publicUrlPath: string;
  title: string;
  heroText?: string | null;
  isParentType: boolean;
  directItemCount: number;
  thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
  tileItemImages: Array<{ __typename?: 'Photo'; id: string; url: string }>;
};

export type CatalogCurationsTreeRootQueryVariables = Types.Exact<{
  types?: Types.InputMaybe<Array<Types.CatalogTreeRootInput> | Types.CatalogTreeRootInput>;
  storefront?: Types.InputMaybe<Types.CatalogStorefront>;
}>;

export type CatalogCurationsTreeRootQuery = {
  __typename?: 'Query';
  productCatalogCategoryTreeRoot: {
    __typename?: 'ProductCatalogCategory';
    id: string;
    publicUrlPath: string;
    title: string;
    heroText?: string | null;
    isParentType: boolean;
    directItemCount: number;
    children: Array<{
      __typename?: 'ProductCatalogCategory';
      id: string;
      publicUrlPath: string;
      title: string;
      heroText?: string | null;
      isParentType: boolean;
      directItemCount: number;
      curationData?: {
        __typename?: 'ProductCatalogCuration';
        id: string;
        videoUrl?: string | null;
        description?: string | null;
        header?: {
          __typename?: 'ProductCatalogCurationHeader';
          id: string;
          textColor?: string | null;
          gradientColor?: string | null;
          gradient1?: string | null;
          gradient2?: string | null;
          title?: string | null;
          eyebrow?: string | null;
          description?: string | null;
          video?: string | null;
          backgroundImage?: { __typename?: 'Photo'; id: string; url: string; blurHash?: string | null } | null;
          logoImage?: { __typename?: 'Photo'; id: string; url: string; blurHash?: string | null } | null;
        } | null;
      } | null;
      children: Array<{
        __typename?: 'ProductCatalogCategory';
        id: string;
        publicUrlPath: string;
        title: string;
        heroText?: string | null;
        isParentType: boolean;
        directItemCount: number;
        thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
        tileItemImages: Array<{ __typename?: 'Photo'; id: string; url: string }>;
      }>;
      thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
      tileItemImages: Array<{ __typename?: 'Photo'; id: string; url: string }>;
    }>;
    thumbnail?: { __typename?: 'PhotoSummary'; url: string } | null;
    tileItemImages: Array<{ __typename?: 'Photo'; id: string; url: string }>;
  };
};

export type CatalogCurationThemeQueryVariables = Types.Exact<{
  url: Types.Scalars['String'];
}>;

export type CatalogCurationThemeQuery = {
  __typename?: 'Query';
  productCatalogCategoryByLocator?: {
    __typename?: 'ProductCatalogCategory';
    id: string;
    curationData?: {
      __typename?: 'ProductCatalogCuration';
      id: string;
      header?: { __typename?: 'ProductCatalogCurationHeader'; id: string; textColor?: string | null; gradientColor?: string | null } | null;
    } | null;
  } | null;
};

export const CatalogCurationHeaderFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogCurationHeader' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogCurationHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'blurHash' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logoImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'blurHash' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'textColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gradientColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gradient1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gradient2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eyebrow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'video' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CatalogCurationFieldsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogCurationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogCategory' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isParentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'directItemCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tileItemImages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CatalogCurationsTreeRootDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CatalogCurationsTreeRoot' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'types' } },
          type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CatalogTreeRootInput' } } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'storefront' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CatalogStorefront' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productCatalogCategoryTreeRoot' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'types' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'types' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'storefront' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'storefront' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogCurationFields' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'children' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogCurationFields' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'curationData' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'header' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogCurationHeader' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'children' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogCurationFields' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogCurationHeader' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogCurationHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'blurHash' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logoImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'blurHash' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'textColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gradientColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gradient1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gradient2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eyebrow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'video' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogCurationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogCategory' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'thumbnail' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isParentType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'directItemCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tileItemImages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCatalogCurationsTreeRootQuery__
 *
 * To run a query within a React component, call `useCatalogCurationsTreeRootQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogCurationsTreeRootQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogCurationsTreeRootQuery({
 *   variables: {
 *      types: // value for 'types'
 *      storefront: // value for 'storefront'
 *   },
 * });
 */
export function useCatalogCurationsTreeRootQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CatalogCurationsTreeRootQuery, CatalogCurationsTreeRootQueryVariables>) {
  return ApolloReactHooks.useQuery<CatalogCurationsTreeRootQuery, CatalogCurationsTreeRootQueryVariables>(CatalogCurationsTreeRootDocument, baseOptions);
}
export function useCatalogCurationsTreeRootLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CatalogCurationsTreeRootQuery, CatalogCurationsTreeRootQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<CatalogCurationsTreeRootQuery, CatalogCurationsTreeRootQueryVariables>(CatalogCurationsTreeRootDocument, baseOptions);
}
export type CatalogCurationsTreeRootQueryHookResult = ReturnType<typeof useCatalogCurationsTreeRootQuery>;
export type CatalogCurationsTreeRootLazyQueryHookResult = ReturnType<typeof useCatalogCurationsTreeRootLazyQuery>;
export type CatalogCurationsTreeRootQueryResult = Apollo.QueryResult<CatalogCurationsTreeRootQuery, CatalogCurationsTreeRootQueryVariables>;
export const CatalogCurationThemeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CatalogCurationTheme' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productCatalogCategoryByLocator' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'url' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'url' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'curationData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'header' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'textColor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gradientColor' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCatalogCurationThemeQuery__
 *
 * To run a query within a React component, call `useCatalogCurationThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogCurationThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogCurationThemeQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCatalogCurationThemeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CatalogCurationThemeQuery, CatalogCurationThemeQueryVariables>) {
  return ApolloReactHooks.useQuery<CatalogCurationThemeQuery, CatalogCurationThemeQueryVariables>(CatalogCurationThemeDocument, baseOptions);
}
export function useCatalogCurationThemeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CatalogCurationThemeQuery, CatalogCurationThemeQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<CatalogCurationThemeQuery, CatalogCurationThemeQueryVariables>(CatalogCurationThemeDocument, baseOptions);
}
export type CatalogCurationThemeQueryHookResult = ReturnType<typeof useCatalogCurationThemeQuery>;
export type CatalogCurationThemeLazyQueryHookResult = ReturnType<typeof useCatalogCurationThemeLazyQuery>;
export type CatalogCurationThemeQueryResult = Apollo.QueryResult<CatalogCurationThemeQuery, CatalogCurationThemeQueryVariables>;
